export default __webpack_public_path__ + "static/media/dol.d87fe0ff.svg";